<template>
	<div class="step-5">
		<h1>Los geht's!</h1>
		<Features/>
		<div class="tag-sections mt-5">
			<section class="tag">
				<b-row>
					<b-col md="6">
						<h2>Deine E-Mail Adresse</h2>
						<FormGroup
							:state="emailValid"
							:invalid-feedback="emailError && emailError.show ? emailError.message : undefined"
							feedback-beneath
						>
							<b-input type="email" v-model="email" @input="emitChangeEvent"/>
						</FormGroup>
					</b-col>
					<b-col md="6">
						<div class="mt-3 mt-md-0">
							<h2>Dein Vorname</h2>
							<FormGroup>
								<b-input v-model="firstName" @input="emitChangeEvent"/>
							</FormGroup>
						</div>
					</b-col>
				</b-row>
			</section>
			<section class="tag">
				<h2>Setz dir ein sicheres Passwort</h2>
				<Password v-model="password" @input="emitChangeEvent"/>
			</section>
			<section v-if="password" class="tag">
				<h2>Für wen suchst du?</h2>
				<b-form-radio-group
					v-model="customerType"
					:options="customerTypeOptions"
					class="mt-0"
					stacked
					@input="emitChangeEvent"
				/>
			</section>
			<section v-if="customerType" class="tag">
				<b-row>
					<b-col md="6">
						<h3>{{ companyTypeTitle }}</h3>
						<SingleSelect
							v-model="companyType"
							:initial-value="companyType"
							:characteristics="meta.companyType"
							label-type="job-profile"
							@input="emitChangeEvent"
						/>
					</b-col>
					<b-col md="6">
						<div class="mt-3 mt-md-0">
							<h3>{{ companySizeTitle }}</h3>
							<SingleSelect
								v-model="companySize"
								:initial-value="companySize"
								:characteristics="meta.companySize"
								label-type="job-profile"
								@input="emitChangeEvent"
							/>
						</div>
					</b-col>
				</b-row>
			</section>
			<section class="tag">
				<PrivacyCheckbox v-model="privacy" @input="emitChangeEvent"/>
			</section>
		</div>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull} from "@/helper/String";
import * as EmailValidator from 'email-validator';
import Password from "@/vue/common/form/Password";
import SingleSelect from "@/vue/characteristic/SingleSelect";
import {mapState} from "vuex";
import FormGroup from "@/vue/common/form/Group.vue";
import Icon from "@/vue/icon/Icon";
import PrivacyCheckbox from "@/vue/common/PrivacyCheckbox.vue";
import {EXTERNAL, INTERNAL} from "@/helper/customer/Type";
import Features from "@/vue/customer/Features.vue";

export default {

	components: {
		Features,
		PrivacyCheckbox,
		Icon,
		SingleSelect,
		FormGroup,
		Password,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			customerType: this.value?.customerType,
			companyType: this.value?.companyType,
			companySize: this.value?.companySize,
			firstName: this.value?.firstName || '',
			email: this.value?.email || '',
			password: undefined,
			privacy: false,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		customerTypeOptions ()
		{
			return [
				{
					value: INTERNAL,
					text: 'Ich suche für unsere Organisation'
				},
				{
					value: EXTERNAL,
					text: 'Ich bin externer Job-/Personalvermittler (Personalberater / Personalvermittler / Personalleasing)'
				},
			];
		},
		companyTypeTitle ()
		{
			return this.customerType === INTERNAL
				? 'Welche Organisationsart habt ihr?'
				: 'Für welche Organisationsart suchst du?';
		},
		companySizeTitle ()
		{
			return this.customerType === INTERNAL
				? 'Wie groß ist eure Organisation?'
				: 'Wie groß ist die Organisation, für die du suchst?';
		},
		firstNameValid ()
		{
			return !isEmptyOrNull(this.firstName);
		},
		emailValid ()
		{
			return !isDefined(this.emailError);
		},
		emailError ()
		{
			if (!EmailValidator.validate(this.email))
			{
				return {
					show: !isEmptyOrNull(this.email),
					message: 'E-Mail Adresse unvollständig/ungültig'
				};
			}

			return null;
		},
		passwordValid ()
		{
			return isDefined(this.password);
		},
		customerTypeValid ()
		{
			return isDefined(this.customerType);
		},
		companyTypeValid ()
		{
			return isDefined(this.companyType);
		},
		companySizeValid ()
		{
			return isDefined(this.companySize);
		},
		valid ()
		{
			return this.customerTypeValid
				&& this.companyTypeValid
				&& this.companySizeValid
				&& this.firstNameValid
				&& this.emailValid
				&& this.passwordValid
				&& this.privacy;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				customerType: this.customerType,
				companyType: this.companyType,
				companySize: this.companySize,
				firstName: this.firstName,
				email: this.email,
				password: this.password,
				valid: this.valid,
			});
		},
	}
}
</script>
